module.exports = __webpack_public_path__ + "img/questions.24dcf224.png";